export function BrowserFrame() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1046.688 32"
      style={{ borderRadius: '8px 8px 0 0' }}
    >
      <rect width="100%" height="32px" fill="#e8e8e8" />
      <circle cx="20" cy="16" r="4" fill="#C0C8D3" />
      <circle cx="36" cy="16" r="4" fill="#C0C8D3" />
      <circle cx="52" cy="16" r="4" fill="#C0C8D3" />
    </svg>
  );
}

export default BrowserFrame;
